<div>
  <div class="q-tab-title">
    <ng-content select="[title1]"></ng-content>
  </div>
  <div class="q-tab-desc">
    <ng-content select="[title2]"></ng-content>
  </div>
  <div class="q-tab-desc">
    <ng-content select="[title3]"></ng-content>
  </div>
  <div class="q-tab-desc">
    <ng-content select="[title4]"></ng-content>
  </div>
  <div class="q-tab-desc">
    <ng-content select="[title5]"></ng-content>
  </div>
  <div class="q-tab-desc">
    <ng-content select="[title6]"></ng-content>
  </div>
</div>
